import { getCookie } from "@insite/client-framework/Common/Cookies";
import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Session, watchForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, RedirectToChangeCustomer, SignInParameter, SignInResult } from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { isVmiAdmin } from "@insite/client-framework/Store/Data/VmiLocations/VmiLocationsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";


type HandlerType = ApiHandler<
SignInParameter,
SignInResult,
{
    tokenSuccessfullyRequested?: boolean;
    authenticatedSession?: Session;
}
>;

export const RedirectToChangeCustomerExtended: HandlerType = props => {
    if (!props.authenticatedSession?.redirectToChangeCustomerPageOnSignIn) {
        watchForOtherTabSessionChange(); // This sign-in failed, but another tab might be successful later on.
        return;
    }

    // bypass Change Customer page when user open invite link from Share List email
    const myListsDetailsPageUrl = getPageLinkByPageType(props.getState(), "MyListsDetailsPage")?.url;
    if (
        props.parameter.returnUrl &&
        myListsDetailsPageUrl &&
        props.parameter.returnUrl.toLowerCase().indexOf(myListsDetailsPageUrl.toLowerCase()) > -1 &&
        props.parameter.returnUrl.toLowerCase().indexOf("invite=") > -1
    ) {
        return;
    }

    const currentMode = getCookie("NavigationMode") || "Storefront";
    const session = getSession(props.getState());
    const settings = getSettingsCollection(props.getState());
    const isUserVmiAdmin = isVmiAdmin(settings.orderSettings, session);
    const homePageUrl = getPageLinkByPageType(props.getState(), "HomePage")?.url;
    const dashboardPageUrl = getPageLinkByPageType(props.getState(), "MyAccountPage")?.url;
    const changeCustomerPageUrl = getPageLinkByPageType(props.getState(), "ChangeCustomerPage")?.url;
};

replaceInChain(chain, RedirectToChangeCustomer, RedirectToChangeCustomerExtended)